function getAllDateData(timelineSelection) {
  // Get date data from each timelineSelection, and aggregate

  const allDateData = [];

  let minDate = new Date();

  timelineSelection.each(function () {
    const parent = d3.select(this.parentNode);

    const datetimeStart = parent.select('.date.start').attr('datetime');
    const datetimeEnd = parent.select('.date.end').attr('datetime');
    const strStart = parent.select('.date.start').html();
    const strEnd = parent.select('.date.end').html();

    const dateStart = new Date(datetimeStart);
    let dateEnd;

    if (datetimeEnd == null) {
      // use today if no end date
      dateEnd = new Date();
    } else {
      dateEnd = new Date(datetimeEnd);
    }

    if (dateStart < minDate) {
      minDate = dateStart;
    }

    const dateData = {
      dateStart,
      dateEnd,
      strStart,
      strEnd,
    };

    allDateData.push(dateData);
  });

  return {
    allDateData,
    minDate,
  };
}


function Timeline(svgSelection, dateData, userOptions) {
  const defaultOptions = {
    minDate: new Date('2009-09-01'),
    markerWidth: 10,
  };

  const options = Object.assign(defaultOptions, userOptions);

  // setup scales and maps
  const dateScale = d3.scaleTime()
      .domain([options.minDate, new Date()]);

  const yScale = d3.scaleLinear()
      .domain([0, 2]);

  function xMap(d) {
    return dateScale(d.x);
  }

  function yMap() {
    return yScale(1);
  }

  const xAxis = d3.axisBottom(dateScale)
    .ticks(10);

  // path generator
  const line = d3.line()
    .x(xMap)
    .y(yMap);

  // data objects
  const domainData = [
    { x: options.minDate },
    { x: new Date() },
  ];

  const eventData = [
    { x: dateData.dateStart },
    { x: dateData.dateEnd },
  ];

  function draw() {
    // ADD SVG ELEMENTS TO CHART
    // DON'T SPECIFY CHART-SIZE-DEPENDENT ATTRIBUTES

    // add graph g
    const graphSelection = svgSelection.append('g')
      .classed('graph', true);

    // add domain path
    const domainPath = graphSelection.append('path')
      .classed('domain', true)
      .attr('marker-end', 'url(#arrow)')
      .attr('marker-start', 'url(#arrow)')
      .datum(domainData);

    // add event path
    const eventPath = graphSelection.append('path')
      .classed('event', true)
      .datum(eventData);

    // add x-axis
    const xAxisSelection = graphSelection.append('g')
      .attr('class', 'x axis');

    this.domainPath = domainPath;
    this.eventPath = eventPath;
    this.xAxisSelection = xAxisSelection;

    this.resize();
  }

  function resize() {
    // UPDATE ALL CHART-SIZE-DEPENDENT ATTRIBUTES AND PROPERTIES
    const margin = options.markerWidth;

    const { width, height } = svgSelection.node().getBoundingClientRect();

    dateScale.range([margin, width - margin]);
    yScale.range([0, height]);

    this.xAxisSelection
        .attr('transform', `translate(0, ${yScale(1)})`)
        .call(xAxis);

    // remove everything but tick marks, and center tick marks over line;
    this.xAxisSelection.selectAll('.domain').remove();
    this.xAxisSelection.selectAll('text').remove();
    this.xAxisSelection.selectAll('.tick line')
        .attr('y1', -5)
        .attr('y2', 5);

    this.domainPath.attr('d', line);
    this.eventPath.attr('d', line);
  }

  return {
    svg: svgSelection,
    dateData,
    draw,
    resize,
  };
}


function createTimelines(userOptions) {
  const defaultOptions = {
    markerWidth: 8,
    markerHeight: 8,
  };

  const options = Object.assign(defaultOptions, userOptions);

  const timelineSelection = d3.selectAll('.timeline');

  // get all date data
  const allData = getAllDateData(timelineSelection);

  if (!Object.prototype.hasOwnProperty.call(options, 'minDate')) {
    options.minDate = allData.minDate;
  }

  // define arrowhead on first svg element
  const defs = timelineSelection.filter((d, i) => i === 0).append('defs');
  defs.append('marker')
      .attr('id', 'arrow')
      .attr('viewBox', '0 -5 10 10')
      .attr('refX', 0)
      .attr('refY', 0)
      .attr('markerWidth', options.markerWidth)
      .attr('markerHeight', options.markerHeight)
      .attr('orient', 'auto-start-reverse')
    .append('path')
      .attr('class', 'arrowHead')
      .attr('d', 'M0,-5L10,0L0,5');

  const allTimelines = [];
  timelineSelection.each(function (d, i) {
    const timeline = new Timeline(d3.select(this), allData.allDateData[i], options);

    timeline.draw();

    allTimelines.push(timeline);
  });

  function resizeTimelines() {
    allTimelines.forEach((timeline) => {
      timeline.resize();
    });
  }

  return {
    allTimelines,
    resizeTimelines,
  };
}

const options = {
  markerWidth: 0,
  markerHeight: 0,
};

const { resizeTimelines } = createTimelines(options);

window.addEventListener('resize', resizeTimelines);

